import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AddBlock } from '@lyearn/molecules';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import Header from '@/components/Form/components/VisibilitySettings/components/RestrictedVisibilitySettingsContent/components/Header';

import { useRestrictedVisibilitySettingsContent } from './hooks/useRestrictedVisibilitySettingsContent';
import { RestrictedVisibilitySettingsContentProps } from './types';

const RestrictedVisibilitySettingsContent: React.FC<RestrictedVisibilitySettingsContentProps> = (
  props,
) => {
  const { t } = useTranslation();
  const {
    value,
    onChange,
    disabled,
    overrides,
    actionLabel,
    label,
    getCountLabel,
    renderSelectedItems,
    renderModal,
    showInfoTooltip,
    addButtonLength,
    isSettingsTabHidden,
    allowGroupCsvImport,
  } = props;

  const { countLabel, onCloseModal, isModalOpen, toggleModal } =
    useRestrictedVisibilitySettingsContent({
      value,
      getCountLabel,
    });

  return (
    <Stack
      className={cn('w-full', overrides?.container?.className, {
        'mt-32': !disabled && !isSettingsTabHidden,
      })}
      direction="col">
      <Header
        countLabel={countLabel}
        disabled={disabled || isSettingsTabHidden}
        label={label ?? t('Common:VisibleTo')}
        overrides={overrides}
        showInfoTooltip={showInfoTooltip}
      />
      {renderSelectedItems({ value, onChange, disabled })}
      {isModalOpen && !disabled
        ? renderModal({ value, onChange, disabled, onClose: onCloseModal, allowGroupCsvImport })
        : null}
      {!disabled && (
        <AddBlock
          className={cn(overrides?.addButton?.className, 'mt-16 w-full')}
          length={addButtonLength}
          title={actionLabel ?? t('Group:Modal.AddGroups')}
          onClick={toggleModal}
        />
      )}
    </Stack>
  );
};

export default RestrictedVisibilitySettingsContent;
